import { z } from 'zod/v4';

export interface IPaymentPreference {
  id?: string;
  userId: string;
  paymentProvider: string;
  paymentMethodId: string;
}

export const PAYMENT_PREFERENCE_SCHEMA: z.ZodType<IPaymentPreference> =
  z.object({
    id: z.uuid().optional(),
    userId: z.string(),
    paymentProvider: z.string(),
    paymentMethodId: z.string(),
  });
